<template>
  <div class="space-y-6 pb-[5px] md:py-[5px] text-[13px] font-light">
    <div
      v-for="item in deliveryItems"
      :key="item.text"
      class="flex items-center"
    >
      <div class="mr-[15px]">
        <UiIcon :name="item.icon" class="size-7 text-primary" />
      </div>
      <div v-html="item.text"></div>
    </div>
  </div>
  <DialogsPurchaseProtection v-model="openPurchaseDialog" />
</template>

<script setup lang="ts">
import { format } from "date-fns";

const props = defineProps<{
  shipDate?: string;
}>();

const { t } = useI18n();
const openPurchaseDialog = ref(false);
const purchaseProtectionBtn = ref<Element | null>(null);
const estimateShipping = props.shipDate
  ? format(new Date(props.shipDate), "EEEE, LLLL dd")
  : t("shippingDateNotAvailable");

const deliveryItems = computed(() => [
  {
    icon: "truck",
    text: t("truckText", { estimateShipping }),
  },
  {
    icon: "label",
    text: t("labelText"),
  },
/* {
    icon: "spin",
    text: t("spinText"),
  }, */
]);

function purchaseProtectionOpen() {
  openPurchaseDialog.value = true;
}

onMounted(() => {
  purchaseProtectionBtn.value = document.querySelector(
    "[data-purchase-protection]",
  );
  if (purchaseProtectionBtn.value) {
    purchaseProtectionBtn.value.addEventListener(
      "click",
      purchaseProtectionOpen,
    );
  }
});

onBeforeUnmount(() => {
  if (purchaseProtectionBtn.value) {
    purchaseProtectionBtn.value.removeEventListener(
      "click",
      purchaseProtectionOpen,
    );
  }
});
</script>
